var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"qll-content"},[_c('Header'),_c('div',{staticClass:"qll-content_body"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }